import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;